import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Search, X, Clock, TrendingUp } from 'lucide-react';
import { useState } from 'react';

const history = ['大理', '成都', '日本', '西藏'];
const hot = ['大理', '成都', '西藏', '新疆', '厦门', '西安', '丽江', '青岛'];

const results = {
  destinations: [{ name: '大理', desc: '风花雪月，浪漫之城' }],
  diaries: [{ title: '大理五日游记', author: '小王' }],
};

const SearchPage = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = () => { if (query.trim()) setHasSearched(true); };

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="sticky top-20 bg-bg-primary/95 backdrop-blur z-10 py-4">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-text-tertiary" />
              <Input autoFocus placeholder="搜索目的地、日记、攻略..." value={query} onChange={(e) => setQuery(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && handleSearch()} className="pl-12 h-12 rounded-btn bg-white border-[#E8E4DF] text-text-primary focus:border-primary focus:ring-primary/20" />
              {query && <button onClick={() => setQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-text-tertiary"><X className="w-4 h-4" /></button>}
            </div>
            <Button onClick={handleSearch} className="bg-primary hover:bg-primary-hover text-white rounded-btn px-6">搜索</Button>
            <Button variant="ghost" onClick={() => navigate(-1)} className="text-text-secondary">取消</Button>
          </div>
        </div>

        {!hasSearched ? (
          <div className="mt-4">
            <div className="mb-6">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-medium text-text-primary flex items-center gap-2"><Clock className="w-4 h-4" /> 搜索历史</h3>
                <button className="text-xs text-text-tertiary hover:text-primary">清空历史</button>
              </div>
              <div className="flex flex-wrap gap-2">
                {history.map((h) => <Badge key={h} onClick={() => { setQuery(h); setHasSearched(true); }} className="cursor-pointer rounded-full bg-white text-text-secondary hover:bg-primary hover:text-white transition-colors">{h}</Badge>)}
              </div>
            </div>
            <div>
              <h3 className="text-sm font-medium text-text-primary flex items-center gap-2 mb-3"><TrendingUp className="w-4 h-4" /> 热门搜索</h3>
              <div className="flex flex-wrap gap-2">
                {hot.map((h) => <Badge key={h} onClick={() => { setQuery(h); setHasSearched(true); }} className="cursor-pointer rounded-full bg-white text-text-secondary hover:bg-primary hover:text-white transition-colors">{h}</Badge>)}
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-4">
            <div className="flex gap-4 mb-4 border-b border-[#E8E4DF] pb-2">
              {['全部', '目的地', '日记', '模板'].map((t) => <button key={t} className="text-sm text-text-secondary hover:text-primary font-medium">{t}</button>)}
            </div>
            {results.destinations.map((r) => (
              <div key={r.name} className="p-3 rounded-card bg-white shadow-card mb-3 cursor-pointer" onClick={() => navigate('/destinations')}>
                <p className="font-medium text-text-primary">{r.name}</p>
                <p className="text-xs text-text-secondary">{r.desc}</p>
              </div>
            ))}
            <Button variant="outline" className="w-full rounded-btn border-[#E8E4DF] mt-4">加载更多</Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPage;
